import React from "react";

import Select from "react-select";

import { Button, ButtonGroup, Dropdown } from "aible";

import CapSlider from "components/Project/CapSlider";

import Slider from "rc-slider";

import { FRONTIER_SLIDERS_VIEW } from "containers/FrontierSliders/FrontierSliders";

import Toggle from "react-toggle";

import styles from "./style.module.css";

export default class Project extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { isShow: props && props.isUserFeedback ? true : false };
  }

  setRangeLimit(runId, [min, max] = [0, 100]) {
    const { updateFrontierPercentProcessedMin, updateFrontierPercentProcessedMax } = this.props;

    if (runId) {
      updateFrontierPercentProcessedMin(runId, min);
      updateFrontierPercentProcessedMax(runId, max);
    }
  }

  render() {
    const {
      project,
      modelGroups,
      selectedScenario,
      username,
      hideHeader,
      subgroup,
      overrideSliderView,
      isUserFeedback,
      showShortListed,
      updateShowShortListed,
      showPending,
      updateShowPending,
      updateSliderView,
      otherColor,
      selectedColor,
      constrainAibleForOne,
      getFrontierPercentProcessedMin,
      getFrontierPercentProcessedMax
    } = this.props;
    let { sliderView } = this.props;

    const { isShow } = this.state;

    if (overrideSliderView !== undefined) {
      sliderView = overrideSliderView;
    }
    return (
      <div style={{ width: "100%" }}>
        {!hideHeader && isUserFeedback !== true ? (
          <div
            className={styles.otherHeader}
            style={{
              justifyContent: "flex-start",
              borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
              padding: "10px"
            }}
          >
            {isShow ? (
              <div className={styles.oHeader}>
                {"Optimal AIs"}
                <div className={styles.feedActions} style={{ marginLeft: "10px" }}>
                  <ButtonGroup>
                    <Button
                      onClick={() => updateSliderView(FRONTIER_SLIDERS_VIEW.CAPACITY)}
                      active={sliderView === FRONTIER_SLIDERS_VIEW.CAPACITY}
                    >
                      {"Capacity"}
                    </Button>
                    <Button
                      onClick={() => updateSliderView(FRONTIER_SLIDERS_VIEW.FRONTIER)}
                      active={sliderView === FRONTIER_SLIDERS_VIEW.FRONTIER}
                    >
                      {"Frontier"}
                    </Button>
                    <Button
                      onClick={() => updateSliderView(FRONTIER_SLIDERS_VIEW.SELECTED)}
                      active={sliderView === FRONTIER_SLIDERS_VIEW.SELECTED}
                    >
                      {"Selected"}
                    </Button>
                    <Button
                      onClick={() => updateSliderView(FRONTIER_SLIDERS_VIEW.FEEDBACK)}
                      active={sliderView === FRONTIER_SLIDERS_VIEW.FEEDBACK}
                    >
                      {"Feedback"}
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
            ) : (
              <div className={styles.lContent}>
                <div className={styles.lHeader}>
                  {"Optimal AIs"}
                  <div className={styles.lSubHeader}>
                    {modelGroups && modelGroups.drilldownValues
                      ? modelGroups.drilldownValues.reduce((a, b) => a + b.numModels, 0) * 50 +
                        " POSSIBILITIES EVALUATED"
                      : ""}
                  </div>
                </div>
                {modelGroups &&
                  modelGroups.drilldownValues &&
                  modelGroups.drilldownValues
                    .filter((d) => d.value !== "Overall" || modelGroups.drilldownValues.length === 1)
                    .filter((d) => subgroup === undefined || (subgroup !== undefined && subgroup === d.value))
                    .map((d, i) => {
                      var counts = {};
                      var count = 0;

                      Object.keys(d.capModels).forEach((k) => {
                        if (counts[d.capModels[k].id] === undefined) {
                          counts[d.capModels[k].id] = 1;
                          count++;
                        }
                      });

                      return (
                        <div className={styles.lItem} key={i}>
                          <div className={styles.hShow} title={d.value}>
                            <div className={styles.aCircle} style={{ background: d.color }} />
                            {d.value}
                          </div>
                          <div className={styles.inputSlider}>
                            <Slider
                              type="range"
                              min={0}
                              max={100}
                              value={d.capValue}
                              handleStyle={
                                false
                                  ? {
                                      backgroundColor: "rgba(0, 0, 0, 0)",
                                      borderColor: "rgba(0, 0, 0, 0)"
                                    }
                                  : {
                                      backgroundColor: d.color,
                                      borderColor: "white",
                                      boxShadow: "0px 0px 6px 1px rgba(81, 47, 119, 0.35)"
                                    }
                              }
                            />
                          </div>
                          <div className={styles.lSubHeader}>{count + " models"}</div>
                        </div>
                      );
                    })}
              </div>
            )}
            <div className={styles.checkboxes}>
              <div className={styles.cHolder} style={{ marginLeft: "10px" }}>
                <span style={{ right: "60px", position: "absolute" }}>{"Show More"}</span>
                <Toggle
                  defaultChecked={isShow}
                  icons={false}
                  onChange={(e) =>
                    this.setState({
                      isShow: e.target.checked
                    })
                  }
                />

                <span
                  className={isShow !== true ? styles.nPosA : styles.yPosA}
                  style={{ fontSize: "12px", fontWeight: "initial" }}
                >
                  {isShow ? "On" : "Off"}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div />
        )}
        <div className={styles.fHideHolder} style={isShow !== true ? { maxHeight: "0px", overflow: "hidden" } : {}}>
          {isUserFeedback !== true && (
            <div className={styles.fHeader}>
              <div className={styles.fHeaderItem} style={{ minWidth: "150px" }}>
                {"Subgroup"}
              </div>
              <div className={styles.fHeaderItem} style={{ flexGrow: 1 }}>
                {"Conservative"}
              </div>
              <div className={styles.fHeaderItem}>{"Aggressive"}</div>
            </div>
          )}
          <div className={styles.frontierHolder}>
            {modelGroups &&
              modelGroups.drilldownValues &&
              modelGroups.drilldownValues
                .filter((d) => d.value !== "Overall" || modelGroups.drilldownValues.length === 1)
                .filter((d) => subgroup === undefined || (subgroup !== undefined && subgroup === d.value))
                .map((d, i) => {
                  const selectedModel = d.capModels[Math.round(d.capValue) + "%"];

                  let retModels = {};

                  const activeSegment = project.segments.filter((s) => s.id === d.segmentId)[0];

                  const currScenario =
                    (selectedScenario && selectedScenario.scenario && selectedScenario.scenario[d.value]) || {};

                  const scenarioSetup = currScenario.setup || {};

                  const currRunId = currScenario.runId;

                  const frontierMin = getFrontierPercentProcessedMin(
                    currRunId,
                    scenarioSetup.frontierPercentProcessedMin
                  );
                  const frontierMax = getFrontierPercentProcessedMax(
                    currRunId,
                    scenarioSetup.frontierPercentProcessedMax
                  );

                  Object.keys(d.capModels).forEach((c) => {
                    retModels[c] = {
                      model_data: d.capModels[c]
                    };
                    if (isUserFeedback) {
                      let retFeedback =
                        activeSegment &&
                        activeSegment.roles &&
                        activeSegment.roles.filter((r) => r.role_user.fullname === username).length > 0 &&
                        activeSegment.roles.filter((r) => r.role_user.fullname === username)[0].preferences &&
                        activeSegment.roles.filter((r) => r.role_user.fullname === username)[0].preferences.feedback
                          ? activeSegment.roles.filter((r) => r.role_user.fullname === username)[0].preferences
                              .feedback[d.capModels[c].id]
                          : undefined;

                      retModels[c].color =
                        selectedModel && retFeedback > 0 ? "#5BCF74" : retFeedback < 0 ? "#F8CD7E" : "#E6E6FC";
                    } else if (sliderView === FRONTIER_SLIDERS_VIEW.FRONTIER) {
                      // Use Default Colors
                    } else if (sliderView === FRONTIER_SLIDERS_VIEW.FEEDBACK) {
                      const retFeedback =
                        activeSegment &&
                        activeSegment.roles &&
                        activeSegment.roles.reduce(
                          (a, b) =>
                            a +
                            (b.preferences &&
                            b.preferences.feedback &&
                            b.preferences.feedback[d.capModels[c].id] !== undefined
                              ? Number(b.preferences.feedback[d.capModels[c].id])
                              : 0),
                          0
                        );

                      retModels[c].color =
                        selectedModel && retFeedback > 0 ? "#5BCF74" : retFeedback < 0 ? "#F8CD7E" : "#E6E6FC";
                    } else if (sliderView === FRONTIER_SLIDERS_VIEW.CAPACITY) {
                      retModels[c].color = "#E6E6FC";
                    } else {
                      retModels[c].color =
                        selectedModel && selectedModel.id === d.capModels[c].id ? "rgba(122, 109, 208, 1)" : "#E6E6FC";
                    }
                  });

                  const userRole =
                    activeSegment &&
                    activeSegment.roles &&
                    activeSegment.roles.filter((r) => r.role_user.fullname === username).length > 0
                      ? activeSegment.roles.filter((r) => r.role_user.fullname === username)[0]
                      : undefined;

                  const hasPP = userRole && userRole.preferences && userRole.preferences.percent_processed;

                  const percentProcessed =
                    userRole && userRole.preferences && userRole.preferences.percent_processed
                      ? userRole.preferences.percent_processed
                      : Math.min(d.capValue, 100);

                  return (
                    <div className={styles.slideSelectHolder} key={i}>
                      <CapSlider
                        key={"cap" + d.value + i}
                        isEditFrontierRange={constrainAibleForOne}
                        updateFrontierRange={(range) => this.setRangeLimit(currRunId, range)}
                        isCapacity={isUserFeedback !== true && sliderView === FRONTIER_SLIDERS_VIEW.CAPACITY}
                        frontierRange={[frontierMin, frontierMax]}
                        impacts={
                          isUserFeedback
                            ? [
                                {
                                  value: percentProcessed,
                                  drilldownValue: d.value
                                }
                              ]
                            : project.settings && project.settings.scenarios
                              ? [
                                  ...project.settings.scenarios
                                    .filter((s, i) =>
                                      showShortListed === false &&
                                      project.settings.originalScenarios &&
                                      project.settings.originalScenarios[i] &&
                                      project.settings.originalScenarios[i].status === "PENDING"
                                        ? false
                                        : true
                                    )
                                    .filter((s, i) =>
                                      showPending === false &&
                                      project.settings.originalScenarios &&
                                      project.settings.originalScenarios[i] &&
                                      project.settings.originalScenarios[i].status === "DRAFT"
                                        ? false
                                        : true
                                    )
                                    .map((s, i) => ({
                                      value: Math.min(s[d.value].capValue, 100),
                                      drilldownValue: "Scenario " + i
                                    })),
                                  {
                                    value: d.capValue,
                                    drilldownValue: d.value
                                  }
                                ]
                              : [
                                  {
                                    value: d.capValue,
                                    drilldownValue: d.value
                                  }
                                ]
                        }
                        currentImpact={percentProcessed}
                        drilldownValue={d.value}
                        capModels={retModels}
                        drilldown={d}
                        otherColor={otherColor}
                        selectedColor={isUserFeedback ? (hasPP ? "#F47C20" : "#7E69D7") : selectedColor}
                      />
                      {/* TODO: Assumption dropdown selection
                  <div style={{ minWidth: "200px", zIndex: 100 - i }}>
                    <Select
                      options={project.roles.map(r => ({
                        label: r.role_user.fullname,
                        value: r.role_user.fullname
                      }))}
                      value={{
                        label: project.roles[0].role_user.fullname,
                        value: project.roles[0].role_user.fullname
                      }}
                    />
                  </div>
                  */}
                    </div>
                  );
                })}
          </div>
        </div>
      </div>
    );
  }
}
